import React from 'react'
import { toast } from 'react-toastify'
import MaterialSymbol from '../components/MaterialSymbol'

export const onClickDeveloper: () => void = () => {
  if (process.env.REACT_APP_AZURE_B2C_LOGIN_REDIRECT_URI !== 'http://localhost:3000/') {
    return
  }
  // Capture the contents of localStorage
  const k = Object.keys(localStorage)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const l: any = {}
  k.forEach((e) => {
    l[e] = localStorage.getItem(e)
  })

  const localStorageString = JSON.stringify(l)
  // Convert the object into a string
  navigator.clipboard.writeText(localStorageString).then(() => {
    toast('Details copied to clipboard', {
      type: 'success',
      icon: <MaterialSymbol>inventory</MaterialSymbol>,
    })
  })

  navigator.clipboard.writeText(localStorageString)
}

export default onClickDeveloper
